import Ably from "ably";
const version = "2.1.2";
let sdkInstance = null;
export class Realtime extends Ably.Realtime.Promise {
    constructor(options) {
        if (typeof options === "string") {
            options = {
                key: options,
            };
        }
        options.agents = { 'react-hooks': version };
        super(options);
    }
}
export function provideSdkInstance(ablyInstance) {
    sdkInstance = ablyInstance;
}
export function configureAbly(ablyConfigurationObject) {
    return sdkInstance || (sdkInstance = new Realtime(ablyConfigurationObject));
}
export function assertConfiguration() {
    if (!sdkInstance) {
        throw new Error('Ably not configured - please call configureAbly({ key: "your-api-key", clientId: "someid" });');
    }
    return sdkInstance;
}
//# sourceMappingURL=AblyReactHooks.js.map